import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskShortCodeAvailabilityVm } from '../osk-short-code-availability-vm.model';
@Injectable({ providedIn: 'root' })
export class OskShortCodeAvailabilityService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OskShortCodeAvailability`;
  }
  get(oskShortCode: string): Observable<IOskShortCodeAvailabilityVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (oskShortCode !== undefined && oskShortCode !== null) {
      params = params.set('oskShortCode', oskShortCode.toString());
    }
    return this.http.get<IOskShortCodeAvailabilityVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
